export default {
  Document: {
    ChooseGrade: 'Chọn khối',
    ChooseSubject: 'Chọn môn',
    ChooseTopic: 'Chọn chủ đề',
    Exercise: 'Bài tập',
    Lesson: 'Bài giảng',
    Topic: 'Chủ đề',
    ContentFeedback: 'Ví dụ: Bài giảng không hấp dẫn, khó nghe, không bổ ích,...'
  }
}
